var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "20px",
    viewBox: "0 0 76 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_M",
    transform: "translate(-54.000000, -78.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(54.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L65.3002739,1 C65.5604747,1 65.8104292,1.10142001 65.9970646,1.28272554 L75.2616397,10.2827255 C75.6577794,10.6675524 75.6669503,11.300651 75.2821234,11.6967907 C75.2753947,11.7037172 75.2685661,11.7105458 75.2616397,11.7172745 L65.9970646,20.7172745 C65.8104292,20.89858 65.5604747,21 65.3002739,21 L1,21 C0.44771525,21 6.76353751e-17,20.5522847 0,20 L0,2 C-6.76353751e-17,1.44771525 0.44771525,1 1,1 Z",
    id: "Rectangle-Copy-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftM);
export default __webpack_public_path__ + "static/media/leftM.87daaf69fb5d8ffd572aaefbfe655d17.svg";
export { ForwardRef as ReactComponent };